<footer>

  <a routerLink="/termsConditions">Terms and Conditions</a>
</footer>
